<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <span [innerHTML]="data.content"></span>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">{{data.button1Label}}</button>
  <button mat-button color="primary" (click)="onYesClick()" *ngIf="data.yesButton">Yes</button>
</div>
